export const hindi={
    home:{
        title:"फीडवेल",
        link1:"होम",
        link2:"बारे में",
        link3:"समीक्षा",
        btn1:"लॉग इन करें",
        btn2:"प्रवेश करें",
        heading1:"कुपोषण क्या है?",
        para1:"कुपोषण वह स्थिति है जो तब विकसित होती है जब शरीर विटामिन, खनिज और अन्य पोषक तत्वों से वंचित हो जाता है जो स्वस्थ ऊतकों और अंग कार्य को बनाए रखने के लिए आवश्यक होता है। कुपोषण उन लोगों में होता है जो या तो कुपोषित हैं या अतिपोषित हैं।",
        cardHeading1:"कारण",
        cardPara1:"कुपोषण के संभावित कारण अनुपयुक्त आहार विकल्प हो सकते हैं, कम आय होना, भोजन प्राप्त करने में कठिनाई, विभिन्न शारीरिक और मानसिक स्वास्थ्य स्थितियां",
        cardHeading2:"लक्षण",
        cardPara2:"वजन कम होना, भूख की कमी या भोजन या पेय में रुचि, थकान और चिड़चिड़ापन, ध्यान केंद्रित करने में असमर्थता, हमेशा ठंड लगना, अवसाद, बीमार होना और घावों को भरने में अधिक समय लगना",
        cardHeading3:"इलाज",
        cardPara3:"चल रही जांच और निगरानी एक आहार योजना बनाना, जिसमें विशिष्ट लक्षणों का इलाज करने वाले पूरक लेना शामिल हो सकता है, कोई भी संक्रमण जो मौजूद हो सकता है किसी भी मुंह या निगलने की समस्याओं की जांच करना वैकल्पिक खाने के बर्तनों का सुझाव देना",
        heading2:"जिन लोगों ने हमें बचाने में मदद की",
        para2:"आंगनवाड़ी में इंटर्नशिप योजना एक ऐसा कार्यक्रम है जो छात्रों, स्वयंसेवकों और व्यक्तियों को समुदाय में कुपोषण उन्मूलन के उद्देश्य से गतिविधियों में भाग लेने की अनुमति देता है। आंगनवाड़ी केंद्र सरकार द्वारा संचालित केंद्र हैं जो छह साल से कम उम्र के बच्चों, गर्भवती महिलाओं और स्तनपान कराने वाली माताओं को बुनियादी स्वास्थ्य देखभाल, पोषण और शिक्षा सेवाएं प्रदान करते हैं। आंगनवाड़ी में इंटर्नशिप योजना लोगों को पोषण कार्यक्रम चलाने और प्रबंधित करने, सामुदायिक आउटरीच आयोजित करने और स्वास्थ्य और स्वच्छता प्रथाओं को लागू करने में व्यावहारिक अनुभव देने के लिए डिज़ाइन की गई है। इस योजना में भाग लेकर, व्यक्ति समुदाय में कुपोषण को कम करने में योगदान दे सकते हैं और इस प्रक्रिया में मूल्यवान कौशल और ज्ञान प्राप्त कर सकते हैं। इस योजना के माध्यम से, आंगनवाड़ी केंद्र कमजोर आबादी को समग्र देखभाल और सहायता प्रदान करने के लिए बेहतर ढंग से सुसज्जित हैं, यह सुनिश्चित करते हुए कि बच्चों और माताओं को उनके स्वस्थ विकास और विकास के लिए पर्याप्त पोषण और देखभाल प्राप्त हो।",
        heading3:"समीक्षाएं जिन्होंने हमें बचाने में मदद की।",
        para3:"आप उन देखभाल केंद्रों की समीक्षा कर सकते हैं जहाँ आपने काम किया है या काम कर रहे हैं, और सुझाव भी दे सकते हैं जो अधिकारियों को बेहतर और सूचित निर्णय लेने में मदद करता है और हमें कुपोषण से लड़ने में भी मदद करता है।",
        bottomBtn:"अपना जोड़ना चाहते हैं, यहां क्लिक करें",
        footerText:"फीडवेल"
    },
    login:{
        heading1:"लॉगिन करें",
        placeholder1:"ईमेल",
        placeholder2:"पासवर्ड",
        btn1:"जारी रखें",
        link1:"खाता नहीं है, एक बनाएँ"
    },
    register:{
        heading1:"रजिस्टर करें",
        placeholder1:"नाम",
        placeholder2:"ईमेल",
        placeholder3:"पासवर्ड",
        btn1:"रजिस्टर",
        link1:"पहले से एक खाता मौजूद है? लॉगिन करें"
    }
}